module.exports = __webpack_public_path__ + "img/特种设备检验@3x.11f43c16.png";